<template>
  <div class="plans">
    <h1>远程授课</h1>
    <a-spin :spinning="liveSpinning">
      <div class="content">
        <div class="result">
          远程授课：<strong>{{ data.length }}门</strong>
        </div>

        <table class="table table-bordered table-hover">
          <tr>
            <!-- <th>房间号</th>
            <th>房间名称</th> -->
            <th style="min-width: 50px;">教师</th>
            <th style="min-width: 100px;">直播主题</th>
            <th style="min-width: 120px;">公告</th>
            <th style="min-width: 190px;">时间</th>
            <th style="min-width: 190px;">计分时间</th>
            <th style="min-width: 90px;">直播观看时长</th>
            <th style="min-width: 270px;">操作</th>
          </tr>

          <tr v-for="(item, index) in data" :key="index">
            <!-- <td class="table-td">{{ item.roomId }}</td>
            <td class="table-td">{{ item.roomName }}</td> -->
            <td class="table-td">{{ item.teacherName }}</td>
            <td class="table-td" style="text-align: left;">{{ item.roomName }}</td>
            <td class="table-td" style="text-align: left;">{{ item.note }}</td>

            <td class="table-td">
              <table class="table" style="margin-bottom: 0;">
                <tr v-for="(item2, index2) in item.times" :key="index2" style="border: none"
                  :class="{ bgcFFF: index % 2 === 0 }">
                  <td style="border: none" class="btnBorder table-td">
                    <div>{{ item2.startTime }}</div>  <div>{{ item2.endTime }}</div>
                    <div style="padding: 3px 10px"> {{ item2.remark }}</div>
                  </td>
                </tr>
              </table>
            </td>
            <td class="table-td">
              <div>{{ item.scoreStartTime }}</div>
              <div>{{ item.scoreEndTime }}</div>
            </td>
            <td class="table-td">{{ item.totalTime }} 分钟</td>

            <td class="table-td">
              <button class="btn btn-inter" style="width: 60px; margin-left: 10px" v-show="show"
                @click="gotoLiveRoom(item)">
                进入</button><button style="margin-left: 5px;background: $bgColor !important;" class="btn btn-info" @click="fn1(item)">
                查看回放
              </button>
            </td>
          </tr>
        </table>
      </div>
    </a-spin>

    <div background-color="grey">
      <div class="back" v-if="showModal" @click="showModal = false"></div>
      <div class="pop" v-if="showModal">
        <table class="table table-bordered table-hover">
          <tr>
            <th>序号</th>
            <th>开始时间</th>
            <th>时长</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in returnList" :key="index" style="vertical-align: middle">
            <td class="table-td">{{ index + 1 }}</td>
            <td class="table-td">{{ item.startTime }}</td>
            <td class="table-td">{{ formatSeconds(item.duration) }}</td>
            <td class="table-td" style="text-align: center; text-indent: 0px">
              <button style="
                  background: #2caf7a;
                  color: #fff;
                  padding: 3px 15px;
                  border-radius: 3px;
                  border: none;
                " @click="searchReturn(item.url)">
                查看
              </button>
            </td>
          </tr>
        </table>

        <button style="margin:20px 0 0 93%;" class="btn btn-info" @click="handleClose()">
          关闭
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PlanList',
  // props: {
  //   arrs: Array
  // },
  data: function () {
    return {
      show: true,
      columns: [
        {
          title: '房间号',
          dataIndex: 'roomId'
        },
        {
          title: '房间名称',
          dataIndex: 'roomName'
        },
        {
          title: '时间',
          dataIndex: 'times'
        }
      ],
      data: [],
      liveSpinning: true,
      showModal: false,
      returnList: []
    }
  },

  mounted() {
    this.getDataInfo() // 远程授课直播列表
  },

  methods: {

    // 时间转化函数
    formatSeconds(value) {
      // var secondTime = parseInt(value);// 秒
      var minuteTime = 0 // 分
      var hourTime = 0 // 小时
      if (value > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(value / 60)
        //获取秒数，秒数取佘，得到整数秒数
        value = parseInt(value % 60)
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60)
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      var result = '' + parseInt(value) + '秒'

      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result
      }
      if (hourTime > 0) {
        result = '' + parseInt(hourTime) + '小时' + result
      }
      return result
    },

    // 弹框(点击查看回放)
    fn1(item) {
      // this.axios.get(`/biz/live/getRecordList?id=${item.id}`).then(res => {
      //   if (res.code === 200) {
      //     this.showModal = true
      //     this.returnList = res.result
      //   }
      // })
      this.axios.get(`/biz/live/getLiveRecordsUrl?id=${item.id}`).then(res => {
        if (res.code === 200) {
          if (res.result.isAlert == 1) {
            this.$confirm({
              title: '提示',
              content: h => <div style="color:red;">{res.result.alertStr}</div>,
              onOk() {
                window.open(res.result.url)
              },
              okText: '继续'
            })
          } else {
            window.open(res.result.url)
          }
        }
      })
    },

    // 查看回放url
    searchReturn(url) {
      window.open(url)
    },

    // 直播列表
    getDataInfo() {
      this.liveSpinning = true
      this.axios.get(`/biz/live/list`).then(res => {
        if (res.success) {
          this.liveSpinning = false
          this.data = res.result
        }
      })
    },

    // 进入房间 url
    gotoLiveRoom(item) {
      let date1 = new Date(item.endTime);
      let date2 = new Date();
      if (date1 > date2) { //结束时间大于当前时间可点击
        this.axios.get(`/biz/live/url?id=${item.id}`).then(res => {
          if (res.success && res.result) {
            window.open(res.result)
          }
        })
      } else {
        this.$message.warning('直播时间已过期，请点击查看回放!')
      }


    },

    handleClose() {
      this.showModal = false
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';
.plans {

  h1 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .content {
    background: #fff;
    padding: 28px;
    min-height: 400px;

    .result {
      background: #f8faf9;
      padding: 20px;
      margin-bottom: 30px;
      color: #999999;

      strong {
        font-weight: bold;
        margin-right: 20px;
        color: #333;
      }
    }
  }

  .btn {
    width: 80px;
    height: 32px;
    line-height: 32px;
    padding: 0;
    background: $bgColor;
    text-align: center;
    color: #fff;
    border: none;
  }

  .active {
    background: $bgColor;
  }

  th {
    text-align: center;
    background: #f6f6f8;
    padding: 12px 6px;
    border-bottom: 1px solid #dee2e6;
  }

  td {
    text-align: center;
    padding: 12px 6px;
    border: 1px solid #dee2e6;
  }

  tr:nth-child(odd) {
    background: #f6f6f8;
  }

  // 最后一个td标签是时间 但是本选择器却在时间中生效
  td:nth-child(3) {
    text-align:left;
    text-indent:50px;
  }

  // 弹框
  .back {
    background-color: #000;
    opacity: 0.3;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1
  }

  .pop {
    background-color: #fff;
    position: fixed;
    top: 200px;
    left: 300px;
    width: calc(100% - 600px);
    z-index: 2
    padding:30px 20px 20px 20px;
  }
}

.btn-inter {
  background: $bgColor !important;
  color: #fff;
}

.bgcFFF {
  background: #fff !important;
}

.table-td {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/distancelearning/components/PlanList.vue